import script from "./BannerComponente.vue?vue&type=script&setup=true&lang=js"
export * from "./BannerComponente.vue?vue&type=script&setup=true&lang=js"

import "./BannerComponente.vue?vue&type=style&index=0&id=6853257b&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6853257b"]])

export default __exports__